// ----------------------------------------------------------------------------
// Product Form Extension: Wishlist Sync
// ----------------------------------------------------------------------------
// Keep the visible PDP wishlist button aligned with the currently selected
// variant so third-party wishlist integrations receive the right variant id.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';

// -------------------------------------
// Wishlist Sync
// -------------------------------------

class ProductFormWishlist {
  constructor(iamForm) {
    var _this$iamForm$getCurr, _this$iamForm;
    this.iamForm = iamForm;
    this.scope = this.iamForm.closest('.product__content') || this.iamForm.parentElement || this.iamForm;
    this.scheduleCleanup = this.scheduleCleanup.bind(this);
    iamotaEventHandler.subscribe('productForm:variant:changed', this.onVariantChange.bind(this), {
      context: this.iamForm,
      source: "product-form--wishlist.js"
    });
    this.observeWishlistInjection();
    this.removeDuplicateWishlistUi();
    this.updateWishlist((_this$iamForm$getCurr = (_this$iamForm = this.iamForm).getCurrentVariant) === null || _this$iamForm$getCurr === void 0 ? void 0 : _this$iamForm$getCurr.call(_this$iamForm));
  }
  onVariantChange(_ref) {
    var {
      variant
    } = _ref;
    this.removeDuplicateWishlistUi();
    this.updateWishlist(variant);
  }
  observeWishlistInjection() {
    var _this$wishlistObserve;
    if (!this.scope) return;
    (_this$wishlistObserve = this.wishlistObserver) === null || _this$wishlistObserve === void 0 || _this$wishlistObserve.disconnect();
    this.wishlistObserver = new MutationObserver(this.scheduleCleanup);
    this.wishlistObserver.observe(this.scope, {
      childList: true,
      subtree: true
    });
  }
  scheduleCleanup() {
    if (this.cleanupScheduled) return;
    this.cleanupScheduled = true;
    requestAnimationFrame(() => {
      this.cleanupScheduled = false;
      this.removeDuplicateWishlistUi();
    });
  }
  removeDuplicateWishlistUi() {
    if (!this.scope) return;
    var duplicateSelectors = ['.swym-wishlist-button-bar', '.swym-button-bar.swym-wishlist-button-bar', '.swym-button.swym-add-to-wishlist:not(.product__wishlist)', '.swym-button.swym-add-to-wishlist-view-product:not(.product__wishlist)'];
    this.scope.querySelectorAll(duplicateSelectors.join(', ')).forEach(element => {
      if (element.closest('.product__wishlist')) return;
      element.remove();
    });
    this.scope.querySelectorAll('.swym-button-bar, .swym-wishlist-button-bar').forEach(container => {
      if (container.querySelector('.product__wishlist')) return;
      if (container.querySelector('.swym-button')) return;
      if (container.childElementCount > 0) return;
      container.remove();
    });
  }
  updateWishlist(variant) {
    var wishlistButtons = this.iamForm.querySelectorAll('.product__wishlist.swym-button');
    wishlistButtons.forEach(button => {
      if (variant !== null && variant !== void 0 && variant.id) {
        button.dataset.variantId = variant.id;
      } else {
        button.removeAttribute('data-variant-id');
      }
    });
  }
  disconnect() {
    var _this$wishlistObserve2;
    (_this$wishlistObserve2 = this.wishlistObserver) === null || _this$wishlistObserve2 === void 0 || _this$wishlistObserve2.disconnect();
  }
}

// -------------------------------------
// Event Listeners
// -------------------------------------

iamotaEventHandler.subscribe('productForm:init', _ref2 => {
  var {
    iamForm
  } = _ref2;
  new ProductFormWishlist(iamForm);
}, {
  source: "product-form--wishlist.js"
});